import * as React from 'react';
export default function SvgHardDrive() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.75a.75.75 0 01.75-.75h14.5a.75.75 0 01.75.75v6.5A1.75 1.75 0 0118.25 20H5.75A1.75 1.75 0 014 18.25v-6.5zm1.5.75v5.75c0 .138.112.25.25.25h12.5a.25.25 0 00.25-.25V12.5h-13z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.729 5.5a.25.25 0 00-.238.173L5.512 11.83a.25.25 0 00-.012.077V14A.75.75 0 014 14v-2.093c0-.182.028-.363.084-.536l1.979-6.157A1.75 1.75 0 017.729 4h8.542c.76 0 1.433.49 1.666 1.214l1.979 6.157c.056.173.084.354.084.536V14a.75.75 0 01-1.5 0v-2.093a.248.248 0 00-.012-.077l-1.979-6.157a.25.25 0 00-.238-.173H7.729z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 15.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zM12 15.25a.75.75 0 01.75-.75h3.5a.75.75 0 010 1.5h-3.5a.75.75 0 01-.75-.75z",
    fill: "currentColor"
  }));
}